module.exports = __webpack_public_path__ + "img/nl.15923aeb.svg";